import { Fragment } from "react";

interface LinkifyProps {
  children: string;
}

export function Linkify({ children }: LinkifyProps) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  const parts = children.split(urlRegex);
  
  return (
    <>
      {parts.map((part, index) => {
        if (part.match(urlRegex)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 hover:underline break-all"
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
          );
        }
        return <Fragment key={index}>{part}</Fragment>;
      })}
    </>
  );
}
